function wu_go_to_news_topics() {

	$('a[href="#topics"]').on('click', function(e){
		e.preventDefault();
		var distance = $('#topics').offset().top - $('.header__container').outerHeight();
		$('body, html').animate({scrollTop: distance}, 0);
	});

}

wu_go_to_news_topics();